import { loader } from 'graphql.macro'

const updateOnlineScheduleCalendarSettingsMutation = loader('./updateOnlineScheduleCalendarSettings.graphql')

export default async function updateOnlineScheduleCalendarSettings ({ dataLoaders, variables }) {
  const response = await dataLoaders.dispatcher.graphQLClient.request(
    updateOnlineScheduleCalendarSettingsMutation,
    { input: variables }
  )
  return response.UpdateOnlineScheduleCalendarSettings
}
